import s from './EmailComposer.scss'
import { InputContainer, KeyValuePairs, FilesUploader, TextEditor } from 'components/ideal-core-ui'
import Select from 'react-select'

const EmailComposer = ({
  setContactEmailFiles,
  setContactEmailTemplate,
  setContactEmailSubject,
  templates,
  contact,
  removeFile,
  index,
  users,
  setCCContacts,
  ccContacts,
  setContactEmailTemplateBody
}) => {
  return (
    <>
      <KeyValuePairs
        className={s.emailSubject}
        pairs={[
          {
            key: 'CC',
            keyClass: [s.subjectLabel],
            valueClass: [s.subjectInput],
            value: (
              <Select
                onChange={value => setCCContacts(index, value)}
                options={users}
                value={ccContacts}
                className={s.usersSelect}
                isMulti
              />
            )
          },
          {
            key: 'Email Subject',
            keyClass: [s.subjectLabel],
            valueClass: [s.subjectInput],
            value: (
              <InputContainer
                type="text"
                text={contact.email?.subject}
                placeholder="Email Subject"
                cb={value => setContactEmailSubject(index, value)}
              />
            )
          },
          {
            key: 'Email Template',
            keyClass: [s.subjectLabel],
            valueClass: [s.subjectInput],
            value: (
              <Select
                value={contact.email?.template}
                onChange={value => setContactEmailTemplate(index, value)}
                className={s.templateSelect}
                options={templates}
                placeholder="Select Email Template"
              />
            )
          }
        ]}
      />
      <FilesUploader
        files={contact.email?.files}
        removeFile={removeFile}
        onDrop={files => setContactEmailFiles(index, files)}
        className={s.uploader}
        filesClassName={s.filesClass}
        entityIndex={index}
      />
      <TextEditor
        id={contact.contactId}
        height="300"
        template={contact.email?.templateBody}
        onChange={note => setContactEmailTemplateBody(index, note)}
        saveInterval="5000"
        hiddenTools={['image']}
      />
    </>
  )
}

export default EmailComposer
